import React from 'react'
import { Grid } from '@material-ui/core'
import { Input } from 'src/components'
import { formatWeightAnimal } from 'src/utils'
import { formatPerimeterAnimal } from 'src/utils/recordValidation'
import { useFormContext } from 'react-hook-form'
import { useStyles } from './styles'
import { WeighingFormData } from './hooks/useWeighing'

export const StandardWeighingFields: React.FC = () => {
  const {
    watch,
    setValue,
    clearErrors,
    formState: { errors }
  } = useFormContext<WeighingFormData>()

  const styles = useStyles()

  return (
    <div className={styles.inputWithEditToggle}>
      <Grid container spacing={3} style={{ marginTop: 8 }}>
        <Grid item xs={12} sm={6} style={{ padding: '0px 12px' }}>
          <Input
            label='Peso(kg)'
            id='peso'
            value={watch('peso') || ''}
            error={errors?.peso?.message}
            placeholder='0,00 KG'
            onChange={(value: string) => {
              const v = value.replace(/[^0-9.,]/g, '')
              setValue('peso', v)
              clearErrors('peso')
            }}
            onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
              const v = (e.target.value || '').replace(/[^0-9.,]/g, '')
              setValue('peso', v as any)
            }}
            onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
              const v = (e.target.value || '').replace(/[^0-9.,]/g, '')
              setValue('peso', formatWeightAnimal(v))
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} style={{ padding: '0px 12px' }}>
          <Input
            label='Perímetro(cm)'
            id='perimetro'
            value={watch('perimetro') || ''}
            error={errors?.perimetro?.message}
            placeholder='0,00 CM'
            onChange={(value: string) => {
              const v = value.replace(/[^0-9.,]/g, '')
              setValue('perimetro', v as any)
              clearErrors('perimetro')
            }}
            onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
              const v = (e.target.value || '').replace(/[^0-9.,]/g, '')
              setValue('perimetro', v as any)
            }}
            onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
              const v = (e.target.value || '').replace(/[^0-9.,]/g, '')
              setValue('perimetro', formatPerimeterAnimal(v) as any)
            }}
          />
        </Grid>
      </Grid>
    </div>
  )
}
